<section role="region" class="wrapper--white">
  <div class="major-partners">
    <h2 class="major-partners__title">
      Une grande mobilisation des acteurs publics, des fédérations et réseaux d&apos;entreprises
      <span class="highlight--emphasis">en faveur de la jeunesse&nbsp;!</span>
    </h2>
    <p>
      Pour offrir une solution à chaque jeune, six partenaires principaux tous mobilisés autour d&apos;une même
      priorité&nbsp;: <b>l&apos;emploi des jeunes.</b>
    </p>
    <ul class="major-partners__logos">
      <li *ngFor="let partner of MAJOR_PARTNERS; trackBy: trackByPartnerId">
        <a [href]="partner.url" target="_blank" [attr.aria-label]="'Lien vers le site de ' + partner.id">
          <img
            [src]="partner.logo | imaginarySrc: 1:partner.size.width:partner.size.height"
            [srcset]="partner.logo | imaginarySrc: 4:partner.size.width:partner.size.height"
            class="major-partners__logos__illustration"
            [alt]="'Logo de ' + partner.id"
            loading="lazy"
          />
        </a>
      </li>
    </ul>
    <a class="btn" [routerLink]="['/', FeaturesRoutingEnum.Partners]">Découvrir les partenaires</a>
  </div>
</section>
